import React from 'react';
import { InfoIcon } from '@domain-group/fe-co-icon';
import * as styles from './rma-disclaimer.style';

const RmaDisclaimer = (): JSX.Element => (
  <div css={styles.banner} data-testid="search-results-2026__rma-disclaimer">
    <InfoIcon size="small" css={styles.icon} />
    <p css={styles.text}>
      Domain does not verify or guarantee RateMyAgent review accuracy.
    </p>
  </div>
);

export default RmaDisclaimer;
